// extracted by mini-css-extract-plugin
export default {"root":"DonateSection_root__CcdIc"};